export default __webpack_public_path__ + "static/media/480_store05-jp-mobile.9d34e3dd.png";